<script>
export default {
  name: 'DeleteLineDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  emits: [
    'cancelDeletion',
    'deleteLine',
  ],
  data () {
    return {
      showDialog: false,
    }
  },
  watch: {
    show (newValue) {
      this.showDialog = newValue
    },
  },
  methods: {
    onDeleteLine () {
      this.$emit('deleteLine')
    },
    onCancelDeletion () {
      this.$emit('cancelDeletion')
    },
  },
}
</script>
<template>
  <v-dialog
    v-model="showDialog"
    width="25%"
    persistent
  >
    <v-card>
      <v-card-title>
        {{ $gettext('Delete a line') }}
      </v-card-title>
      <v-card-text>
        {{ $gettext('Are you sure to delete this line?') }}
      </v-card-text>
      <v-card-actions>
        <v-btn
          size="small"
          variant="elevated"
          color="secondary"
          :text="$gettext('Cancel')"
          @click="onCancelDeletion"
        />
        <v-btn
          size="small"
          variant="elevated"
          color="primary"
          :text="$gettext('Delete')"
          @click="onDeleteLine"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
